import React from 'react';
import styled from 'styled-components';

const TitleRow = styled.div`
  margin-bottom: 10px;
  font-size: 32px;
  font-weight: bold;

  @media (max-width: 1199px) {
    display: flex;
  }
`;

const Heading = styled.div`
  color: #000000;
  font-family: Oswald;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px;
  text-transform: uppercase;
`;

const MobileLogo = styled.div`
  display: none;
  @media (max-width: 1199px) {
    display: block;
    height: 50px;
  }
`;

export default ({ title, ocLogoURL}) => (
  <TitleRow>
    <Heading dangerouslySetInnerHTML={{ __html: title }} />
    <MobileLogo>
      <img src={ocLogoURL} alt="Owens Corning logo" width="50" />
    </MobileLogo>
  </TitleRow>
);
